import { render, staticRenderFns } from "./DocumentFileUpload.vue?vue&type=template&id=5f1644ec&scoped=true"
import script from "./DocumentFileUpload.vue?vue&type=script&lang=js"
export * from "./DocumentFileUpload.vue?vue&type=script&lang=js"
import style0 from "./DocumentFileUpload.vue?vue&type=style&index=0&id=5f1644ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1644ec",
  null
  
)

export default component.exports